import { frontendURL } from '../../../helper/URLHelper';
import HomePage from './HomePage.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/home'),
    name: 'account_home',
    component: HomePage,
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
